/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Trial_FcInputs */

const en_fc_cmp_trial_fc = /** @type {(inputs: Fc_Cmp_Trial_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not needed`)
};

/**
* | output |
* | --- |
* | "Not needed" |
*
* @param {Fc_Cmp_Trial_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_trial_fc = /** @type {((inputs?: Fc_Cmp_Trial_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Trial_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_trial_fc(inputs)
});
export { fc_cmp_trial_fc as "fc.cmp.trial.fc" }